<template>
    <div class="covid-banner">
      <div>
    <vue-cookie-accept-decline
    :elementId="'myPanel2'"
    :debug="false"
    :type="'floating'"
    :position="'center'"
    :disableDecline="true"
    :transitionName="'slideFromBottom'"
    :showPostponeButton="false"
    :forceCookies="false"
    @status="cookieStatus"
    @clicked-accept="cookieClickedAccept"
    @clicked-decline="cookieClickedDecline">

    <!-- Optional -->
    <!-- <div slot="postponeContent">
        &times;
    </div> -->

    <!-- Optional -->
    <div slot="message">
      <div v-if="this.myLang == 'it'">
        <h2>{{this.occhielloIt}}</h2>
        <h1>{{this.titleIt}}</h1>
        <p v-html="this.textIt"></p>
      </div>
      <div v-if="this.myLang == 'en'">
        <h2>{{this.occhielloEn}}</h2>
        <h1>{{this.titleEn}}</h1>
        <p v-html="this.textEn"></p>
      </div>
    </div>

    <!-- Optional -->
    <!-- <div slot="declineContent">
       OPT OUT
    </div> -->

    <!-- Optional -->
    <div slot="acceptContent">
        <span v-if="this.myLang == 'it'">
            Chiudi     
        </span>
        <span v-else>
            Close
        </span>
    </div>
    </vue-cookie-accept-decline>
    </div>
    </div>
</template>

<script>
import VueCookieAcceptDecline from 'vue-cookie-accept-decline'
import 'vue-cookie-accept-decline/dist/vue-cookie-accept-decline.css'

export default {
  name: 'Header',
  components:{
    VueCookieAcceptDecline
  },
  data:()=>{
    return {
        text:"",
        lang:"",
        myLang:"",
        acceptedCookie:false,
        status: null,
        occhielloIt:"Tudor Nicolaou Studio Legale Associato",        
        titleIt:"Emergenza COVID-19",
        textIt:`<p>Al fine di ridurre il rischio di contagio in conformità alle disposizioni vigenti e alle Linee Guida per gli studi professionali connesse all’emergenza sanitaria da COVID-19, lo Studio ha adottato un Protocollo di Sicurezza, che soci, collaboratori e personale amministrativo si sono impegnati a rispettare.
L’accesso allo Studio è consentito previo appuntamento via e-mail, telefono o modulo di contatto presente su questo sito. Laddove possibile, gli appuntamenti si terranno mediante l’utilizzo di piattaforme per l’organizzazione di riunioni a distanza.</p>`,
        occhielloEn:"Tudor Nicolaou Law Firm",        
        titleEn:"COVID-19 Emergency",
        textEn:`<p>In order to prevent and reduce the risk of infection in accordance with the legal provisions in force and with the Guidelines for Offices related to COVID-19 health emergency, our Firm adopted a Safety Protocol, that partners, collaborators and staff have committed to respect. 
                        Access to the Firm is allowed only by appointment (e-mail, telephone or contact form). Where possible, meetings will be online, using dedicated tools.</p>`
    }
  },
  props: {
    msg: String,
  },
  methods: {
    cookieStatus (status) {
      console.log('status: ' + status)
      this.status = status
    },
    cookieClickedAccept () {
      console.log('here in accept')
      this.status = 'accept'
    },
    cookieClickedDecline () {
      console.log('here in decline')
      this.status = 'decline'
    },
    cookieRemovedCookie () {
      console.log('here in cookieRemoved')
      this.status = null
      this.$refs.myPanel1.init()
    },
    removeCookie () {
      console.log('Cookie removed')
      this.$refs.myPanel1.removeCookie()
    },
  },
  mounted() {
    this.myLang = this.$route.params.lang
    console.log('ml',this.$route);
  },
}
</script>

<style  lang="scss">
#myPanel2{

  width: auto;
    z-index: 99;
    border-radius: 0px;
    bottom: 0;
    background: transparent;
    margin: 0;
    display: block;
    border: 0px;
    box-shadow: none;
    max-height: none;
    max-width: none;
    h2 {
    color: #fff;
  }
  h1 {
    font-size: 1.2rem;
    margin-bottom: 0.11rem;
    color: #fff;
  }
  p{
    font-size: 0.8125rem;
    line-height: 1.4rem;
    color: #fff;
  }
  a{
    color: #F04533;
  }
  button {
    color: #F04533;
    background: transparent;
    border: 0px;
    font-weight: 600;
    font-size: 0.8125rem;
    float: right;
  }
}
.cookie__floating__content {
    padding: 0;
  max-height: none;
}
.cookie__floating__content {
    padding: 0;
}
.cookie__floating__content {
    overflow: visible;
}
.cookie__floating__content {
  margin: 0;
}
.cookie__floating__content{
  padding:5px 20px 0px 20px ;
}
.cookie.cookie__floating.cookie__floating--bottom-right button{
  text-align: right;
  padding-right: 50px;
}

@media (max-width:992px){
  .cookie.cookie__floating.cookie__floating--bottom-right{
    width: calc(100% - 30px);
    margin: 0px auto;
    left: 50%;
    transform: translateX(-50%);
  }
}
@media (max-width:768px){
  .cookie.cookie__floating.cookie__floating--bottom-right{
    width: 100% ;
    margin: 0px auto;
    left: 50%;
      padding: 0.9rem 0rem 1rem 0rem;
    transform: translateX(-50%);
  }
  .cookie.cookie__floating.cookie__floating--bottom-right:before {
    display: none;
}
}

</style>
